import styled from "styled-components";

type ChartPriceLabelProps = {
  top: string;
  ethPrice: number | string;
  color: string;
};

const StyledChartPriceLabel = styled.div<{ $color: string }>`
  width: 170px;
  height: 72px;

  display: inline-block;
  background-color: ${({ $color }) => $color};
  color: #000; /* Black text color */
  padding: 10px 20px;
  font-family: "Arial", sans-serif;
  font-size: 24px;
  font-weight: bold;
  border-radius: 5px; /* Rounded corners */

  position: absolute;
  right: 0px;
  transform: translateY(-50%);

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.25rem;

  p {
    font-size: 1rem;
    line-height: 1.25rem;
    font-family: Inter;
    font-weight: 400;
  }

  h5 {
    font-family: Space Grotesk;
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: 500;
  }

  p,
  h5 {
    color: black;
    text-align: right;
  }

  &::before {
    content: "";
    position: absolute;
    right: 168px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 35px solid transparent;
    border-bottom: 35px solid transparent;
    border-right: 35px solid ${({ $color }) => $color};
  }
`;

export const ChartPriceLabel = ({
  top,
  ethPrice,
  color,
}: ChartPriceLabelProps) => {
  return (
    <>
      <StyledChartPriceLabel style={{ top }} $color={color}>
        <p>Live ETH price</p>
        <h5>{ethPrice}</h5>
      </StyledChartPriceLabel>
    </>
  );
};
